export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5575.a53bb108.jpg";